import { render, staticRenderFns } from "./FundCards.vue?vue&type=template&id=f3d4c576&scoped=true"
import script from "./FundCards.vue?vue&type=script&lang=js"
export * from "./FundCards.vue?vue&type=script&lang=js"
import style0 from "./FundCards.vue?vue&type=style&index=0&id=f3d4c576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d4c576",
  null
  
)

export default component.exports